<template>
  <div class="bg-field">
    <label
      :class="`bg-field__label ${directions && 'bg-field__label--bold'}`"
      v-if="label"
      :for="name"
    >
      {{ label }}
      <bg-tooltip :dark="true" class="bg-field__icon-container" v-if="info">
        <template slot="content">
          <div v-html="info"></div>
        </template>
        <template slot="target">
          <bg-icon class="bg-field__icon" name="information" />
        </template>
      </bg-tooltip>
    </label>
    <div
      v-if="directions"
      v-html="directions"
      class="bg-field__directions"
    ></div>
    <slot></slot>
    <bg-error :error="error" />
  </div>
</template>

<style scoped>
@import "./styles.css";
</style>

<script>
import BgError from "@/components/bg-error";
import BgIcon from "@/components/bg-icon";
import BgTooltip from "@/components/bg-tooltip";
export default {
  name: "BgField",
  components: {
    BgError,
    BgIcon,
    BgTooltip,
  },
  props: {
    name: {
      type: String,
      default: "TextInput",
    },
    label: {
      type: String,
    },
    info: {
      type: String,
    },
    error: {
      type: String,
    },
    directions: {
      type: String,
    },
  },
};
</script>
